<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1236'>
  <div class="visible-lg">
    <div class="flex-container">
      <div class='flex-15'>
        <div class="bmw-profile-content-sidebar">
          <app-user-profile-manager-sidebar></app-user-profile-manager-sidebar>
        </div>
      </div>
      <div class='flex-5'></div>
      <div class="flex-40">
        <div [ngSwitch]='section' class="bmw-profile-content">
          <ng-template [ngSwitchCase]='"info"'>
            <app-manage-user-info></app-manage-user-info>
          </ng-template>
          <ng-template [ngSwitchCase]='"change-password"'>
            <app-manage-password></app-manage-password>
          </ng-template>
          <ng-template [ngSwitchCase]='"billing"'>
            <app-manage-billing></app-manage-billing>
          </ng-template>
          <ng-template [ngSwitchCase]='"companion"'>
            <app-manage-companion-account></app-manage-companion-account>
          </ng-template>
          <ng-template [ngSwitchCase]='"bulletin-manager"'>
            <app-manage-saved-bulletins></app-manage-saved-bulletins>
          </ng-template>
          <ng-template [ngSwitchCase]='"account-recovery"'>
            <app-account-recovery></app-account-recovery>
          </ng-template>
          <ng-template [ngSwitchCase]='"manage-devices"'>
            <app-manage-devices></app-manage-devices>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth > 991 && screenWidth < 1230'>
  <div class="visible-md">
    <div class="flex-container">
      <div class='flex-15'>
        <div class="bmw-profile-content-sidebar bmw-md">
          <app-user-profile-manager-sidebar></app-user-profile-manager-sidebar>
        </div>
      </div>
      <div class='flex-5'></div>
      <div class="flex-40">
        <div [ngSwitch]='section' class="bmw-profile-content">
          <ng-template [ngSwitchCase]='"info"'>
            <app-manage-user-info></app-manage-user-info>
          </ng-template>
          <ng-template [ngSwitchCase]='"change-password"'>
            <app-manage-password></app-manage-password>
          </ng-template>
          <ng-template [ngSwitchCase]='"billing"'>
            <app-manage-billing></app-manage-billing>
          </ng-template>
          <ng-template [ngSwitchCase]='"companion"'>
            <app-manage-companion-account></app-manage-companion-account>
          </ng-template>
          <ng-template [ngSwitchCase]='"bulletin-manager"'>
            <app-manage-saved-bulletins></app-manage-saved-bulletins>
          </ng-template>
          <ng-template [ngSwitchCase]='"account-recovery"'>
            <app-account-recovery></app-account-recovery>
          </ng-template>
          <ng-template [ngSwitchCase]='"manage-devices"'>
            <app-manage-devices></app-manage-devices>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tablet HTML -->
<div *ngIf='screenWidth > 767 && screenWidth < 991'>
  <div class="visible-sm">
    <div class="flex-container">
      <div class='flex-15'>
        <div class="bmw-profile-content-sidebar">
          <app-user-profile-manager-sidebar></app-user-profile-manager-sidebar>
        </div>
      </div>
      <div class='flex-5'></div>
      <div class="flex">
        <div [ngSwitch]='section' class="bmw-profile-content">
          <ng-template [ngSwitchCase]='"info"'>
            <app-manage-user-info></app-manage-user-info>
          </ng-template>
          <ng-template [ngSwitchCase]='"change-password"'>
            <app-manage-password></app-manage-password>
          </ng-template>
          <ng-template [ngSwitchCase]='"billing"'>
            <app-manage-billing></app-manage-billing>
          </ng-template>
          <ng-template [ngSwitchCase]='"companion"'>
            <app-manage-companion-account></app-manage-companion-account>
          </ng-template>
          <ng-template [ngSwitchCase]='"bulletin-manager"'>
            <app-manage-saved-bulletins></app-manage-saved-bulletins>
          </ng-template>
          <ng-template [ngSwitchCase]='"account-recovery"'>
            <app-account-recovery></app-account-recovery>
          </ng-template>
          <ng-template [ngSwitchCase]='"manage-devices"'>
            <app-manage-devices></app-manage-devices>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="flex-container">
      <div class="flex">
        <div [ngSwitch]='section' class="bmw-profile-content">
          <ng-template [ngSwitchCase]='"info"'>
            <app-manage-user-info></app-manage-user-info>
          </ng-template>
          <ng-template [ngSwitchCase]='"change-password"'>
            <app-manage-password></app-manage-password>
          </ng-template>
          <ng-template [ngSwitchCase]='"billing"'>
            <app-manage-billing></app-manage-billing>
          </ng-template>
          <ng-template [ngSwitchCase]='"companion"'>
            <app-manage-companion-account></app-manage-companion-account>
          </ng-template>
          <ng-template [ngSwitchCase]='"bulletin-manager"'>
            <app-manage-saved-bulletins></app-manage-saved-bulletins>
          </ng-template>
          <ng-template [ngSwitchCase]='"account-recovery"'>
            <app-account-recovery></app-account-recovery>
          </ng-template>
          <ng-template [ngSwitchCase]='"manage-devices"'>
            <app-manage-devices></app-manage-devices>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>